<template>
  <div class="modal fade" id="clienteModal" tabindex="-1" aria-hidden="true" ref="modalElement">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-navy">
          <h4 class="modal-title">
            <i class="fas fa-user-tie mr-2"></i>
            <span v-if="isEditing && form.id">Ficha del Cliente: {{ form.nombre }}</span>
            <span v-else>Registrar Nuevo Cliente</span>
          </h4>
          <button type="button" class="close text-white" data-dismiss="modal" @click="cerrar">&times;</button>
        </div>

        <form @submit.prevent="guardar">
          <div class="modal-body position-relative">
            <div v-if="cargandoDatos" class="text-center py-4">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="mt-2">Sincronizando datos...</p>
            </div>

            <div v-else class="row">
              <div class="col-md-6 border-right">
                <h6 class="text-navy font-weight-bold mb-3"><i class="fas fa-id-card"></i> Datos Identitarios</h6>
                
                <div class="form-group">
                  <label>Código Interno</label>
                  <input type="text" class="form-control text-uppercase" v-model="form.codigo" 
                    placeholder="EJ: CLI-001" :disabled="isEditing" />
                </div>

                <div class="form-group">
                  <label>RIF / C.I. <span class="text-danger">*</span></label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <select v-model="form.rif_prefijo" class="form-control" 
                        style="border-top-right-radius: 0; border-bottom-right-radius: 0;"
                        :disabled="isEditing">
                        <option value="V">V</option>
                        <option value="E">E</option>
                        <option value="J">J</option>
                        <option value="G">G</option>
                        <option value="P">P</option>
                      </select>
                    </div>
                    <input type="text" class="form-control" v-model="form.rif_numero" 
                      placeholder="12345678" maxlength="9" @input="soloNumerosRif"
                      :disabled="isEditing" required />
                  </div>
                  <small class="text-muted">Seleccione prefijo y escriba entre 8 y 9 dígitos.</small>
                </div>

                <div class="form-group">
                  <label>Razón Social / Negocio <span class="text-danger">*</span></label>
                  <input type="text" class="form-control text-uppercase" v-model="form.nombre" 
                    placeholder="EJ: ABASTO LOS PINOS" required :disabled="isEditing" />
                </div>

                <div class="form-group">
                  <label>Contribuyente <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="form.tipo_contribuyente" required :disabled="isEditing && !editMode">
                    <option value="ordinario">CONTRIBUYENTE ORDINARIO</option>
                    <option value="especial">CONTRIBUYENTE ESPECIAL</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <h6 class="text-navy font-weight-bold mb-3"><i class="fas fa-map-marker-alt"></i> Ubicación y Contacto</h6>

                <div class="form-group">
                  <label>Encargado</label>
                  <input type="text" class="form-control text-uppercase" v-model="form.encargado" 
                    placeholder="EJ: JUAN PEREZ" :disabled="isEditing && !editMode" />
                </div>

                <div class="form-group">
                  <label>Teléfono <span class="text-danger">*</span></label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <select v-model="form.tel_prefijo" class="form-control" 
                        style="border-top-right-radius: 0; border-bottom-right-radius: 0;"
                        :disabled="isEditing && !editMode">
                        <option value="0412">0412</option>
                        <option value="0414">0414</option>
                        <option value="0424">0424</option>
                        <option value="0422">0422</option>
                        <option value="0416">0416</option>
                        <option value="0426">0426</option>
                      </select>
                    </div>
                    <input type="text" 
                      class="form-control" 
                      v-model="form.tel_numero" 
                      placeholder="1234567"
                      maxlength="7"
                      @input="soloNumerosTel"
                      :disabled="isEditing && !editMode"
                      required />
                  </div>
                  <small class="text-muted">Seleccione el código y escriba los 7 números restantes.</small>
                </div>

                <div class="form-group">
                  <label>Dirección Física <span class="text-danger">*</span></label>
                  <textarea class="form-control text-uppercase" v-model="form.direccion" rows="2" 
                    placeholder="EJ: AV. PRINCIPAL PUERTO LA CRUZ" required :disabled="isEditing"></textarea>
                </div>

                <div class="form-group">
                  <label>Empresa de Comercialización <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="form.empresa_id" required :disabled="isEditing">
                    <option value="" disabled>Seleccione una empresa...</option>
                    <option v-for="emp in empresas" :key="emp.id" :value="emp.id">{{ emp.nombre }}</option>
                  </select>
                </div>
              </div>

              <div class="col-12 mt-3 border-top pt-3" v-if="isEditing">
                <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                  <input type="checkbox" v-model="form.estatus" class="custom-control-input" id="swEstatus" :disabled="!editMode">
                  <label class="custom-control-label" for="swEstatus">
                    Estatus: {{ form.estatus ? 'ACTIVO (Permite Facturación)' : 'INACTIVO (Crédito Bloqueado)' }}
                  </label>
                </div>
                <small class="text-warning" v-if="editMode && !form.estatus">
                  <i class="fas fa-exclamation-triangle"></i> El sistema verificará saldos pendientes antes de desactivar.
                </small>
              </div>
            </div>
          </div>

          <div class="modal-footer justify-content-between bg-light">
            <button type="button" class="btn btn-outline-danger" @click="eliminar" v-if="isEditing">
              <i class="fas fa-trash-alt mr-1"></i> Borrar
            </button>
            <div v-else></div>

            <div>
              <button type="button" class="btn btn-warning mr-2" v-if="isEditing && !editMode" @click="editMode = true">
                <i class="fas fa-edit mr-1"></i> Editar Ficha
              </button>
              <button type="submit" class="btn btn-success px-4" v-if="editMode || !isEditing">
                <i class="fas fa-save mr-1"></i> {{ isEditing ? "Actualizar" : "Registrar Cliente" }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { loading } from '@/plugins/loading';
import { alert } from '@/plugins/alert';

export default {
  name: "ClienteModal",
  props: {
    cliente: { type: Object, default: () => ({}) },
    origen: { type: String, default: 'frecuente' }
  },
  data() {
    return {
      editMode: false,
      cargandoDatos: false,
      form: this.initForm(),
      empresas: []
    };
  },
  computed: {
    isEditing() { return !!(this.cliente && this.cliente.id); }
  },
  watch: {
    cliente: {
      immediate: true,
      handler(newVal) {
        this.form = this.initForm(newVal);
        this.editMode = !newVal.id; // Modo edición activo si es nuevo
      }
    }
  },
  methods: {
    initForm(data = {}) {
      const rifCompleto = data.rif || "";
      const telCompleto = data.telefono || "";
      return {
        id: data.id || null,
        codigo: data.codigo || "",
        rif_prefijo: rifCompleto.charAt(0) || "V",
        rif_numero: rifCompleto.slice(1) || "",
        tel_prefijo: telCompleto.slice(0, 4) || "0412",
        tel_numero: telCompleto.slice(4) || "",
        nombre: data.nombre || "",
        encargado: data.encargado || "",
        email: data.email || "",
        tipo_contribuyente: data.tipo_contribuyente || "ordinario",
        direccion: data.direccion || "",
        empresa_id: data.empresa_id || "",
        estatus: data.estatus !== undefined ? Boolean(data.estatus) : true
      };
    },
    soloNumerosRif(e) {
      this.form.rif_numero = e.target.value.replace(/\D/g, "");
    },
    soloNumerosTel(e) {
      this.form.tel_numero = e.target.value.replace(/\D/g, "");
    },
    async guardar() {
      if (this.form.tel_numero.length !== 7) {
        return alert.toast({ 
          title: 'Número incompleto', 
          text: 'El teléfono debe tener exactamente 7 dígitos después del código.', 
          icon: 'warning' 
        });
      }

      if (this.form.rif_numero.length < 7) {
        return alert.toast({ 
          title: 'RIF inválido', 
          text: 'El número debe tener al menos 7 dígitos.', 
          icon: 'warning' 
        });
      }

      try {
        loading.show('Guardando cliente...');
        const tip = (this.origen === 'frecuente') ? "clientes" : "clientes-ocasionales";
        
        // Normalización de datos antes de enviar
        const payload = { 
          ...this.form,
          rif: (this.form.rif_prefijo + this.form.rif_numero).toUpperCase(),
          telefono: this.form.tel_prefijo + this.form.tel_numero,
          nombre: this.form.nombre.trim().toUpperCase(),
          direccion: this.form.direccion.trim().toUpperCase()
        };

        let response;
        if (!this.isEditing) {
          response = await api.post(`/${tip}`, payload);
        } else {
          // El controlador solo permite actualizar ciertos campos
          response = await api.put(`/${tip}/${this.form.id}`, payload);
        }

        loading.hide();
        alert.toast({ title: '¡Datos actualizados!', icon: 'success' });
        this.editMode = false;
        this.$emit("actualizar");
        window.$("#clienteModal").modal("hide");

      } catch (error) {
        loading.hide();
        this.manejarError(error);
      }
    },
    async eliminar() {
      const result = await alert.show({
        title: '¿Eliminar registro?',
        text: `Confirma que desea borrar a "${this.form.nombre}".`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar permanentemente'
      });

      if (result.isConfirmed) {
        try {
          loading.show('Eliminando de la base de datos...');
          const tip = (this.origen === 'frecuente') ? "clientes" : "clientes-ocasionales";
          await api.delete(`/${tip}/${this.form.id}`);
          
          loading.hide();
          alert.toast({ title: 'Cliente eliminado', icon: 'success' });
          this.$emit("actualizar");
          window.$("#clienteModal").modal("hide");
        } catch (error) {
          loading.hide();
          this.manejarError(error);
        }
      }
    },
    manejarError(error) {
      const data = error.response?.data;
      const status = error.response?.status;
      
      let titulo = data?.message || 'Error en la operación';
      let detalle = data?.detalles || 'Verifique los datos e intente nuevamente.';
      const sugerencia = data?.suggestion ? `\n\n💡 ${data.suggestion}` : '';

      alert.toast({ 
        title: titulo, 
        text: detalle + sugerencia, 
        icon: (status === 403 || status === 422) ? 'warning' : 'error',
        timer: 8000 
      });
    },
    cerrar() { this.$emit("cerrar"); },
    async cargarEmpresas() {
      this.cargandoDatos = true;
      try {
        const { data } = await api.get('/empresa');
        this.empresas = data;
      } catch (e) {
        console.error("Error empresas:", e);
      } finally {
        this.cargandoDatos = false;
      }
    }
  },
  mounted() {
    this.cargarEmpresas();
  }
};
</script>